module.exports = __webpack_public_path__ + "static/media/portfolio-2.cad86467.jpg";